export const environment = {
  production: true,
  ipInfo: "https://api.ipregistry.co/?key=1h0qn5kgc4flucjw",
  ipify: "https://api.ipify.org/?format=json",
  Staging: false,
  tokenKeyName: "_____MOPC_SORTEO_USER_____",
  configFile: "config.json",
};
